import { useCallback } from 'react';

import { PUBLIC_BASE_URL_ENV } from 'tools/environments';

import { Icon } from 'core/generic/elements/icons';

import { getClub, getClubImagePath } from '@login/lib/club';

import styles from './simple-header.module.scss';

export const SimpleHeader = () => {
	const clubName = getClub().shortName;
	const logoUrl = getClubImagePath('crest.svg');

	const handleGoBack = useCallback(() => {
		window.history.back();
	}, []);

	return (
		<div className={styles['header-navigation']}>
			<div
				className={`container ${styles['container']} ${styles['center']}`}
			>
				<button
					onClick={handleGoBack}
					rel="noopener noreferrer"
					className={styles.back}
					aria-label="back button"
				>
					<Icon variant="ChevronLeft" className={styles.icon} />
				</button>
				<a
					href={PUBLIC_BASE_URL_ENV}
					className={styles.crest}
					aria-label={clubName}
				>
					<img src={logoUrl} alt={clubName} />
				</a>
			</div>
		</div>
	);
};

export default SimpleHeader;
